import { ca } from '@cian/analytics';

export const trackClickChatOpen = (productId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'WebIM',
    action: 'Click',
    label: 'StartChat',
    page: {
      extra: {
        productId,
      },
    },
  });
};

export const trackClickChatClose = (productId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'WebIM',
    action: 'Click',
    label: 'EndChat',
    page: {
      extra: {
        productId,
      },
    },
  });
};
